import React, { useState } from 'react';

import { ButtonWithIcon } from './ButtonWithIcon';
import { faAngleDoubleDown, faAngleDoubleUp } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'next-i18next'

export const CollapsibleFilter: React.FunctionComponent<{
    component: React.ReactNode
}> = ({ component }) => {

    const [isOpen, setIsOpen] = useState<boolean>(false)

    const { t } = useTranslation("footer")

    return (
        <div className='mb-4'>
            <div className="row justify-content-end">
                <div className='col-6 col-12'>
                    <ButtonWithIcon
                        icon={isOpen ? faAngleDoubleUp : faAngleDoubleDown}
                        className="mb-4 oa-btn btn btn-primary float-end"
                        name={isOpen ? "Hide Filter" : "Show Filter"}
                        onClick={() => setIsOpen(!isOpen)}
                    />
                </div>
            </div>

            <div className={`collapse ${isOpen ? "show" : ""}`}>
                {isOpen && component}
            </div>

        </div>
    )
}